var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.92559 11L14.4631 15.5375L13.1669 16.8337L7.33325 11L13.1669 5.16632L14.4631 6.46249L9.92559 11Z","fill":"#FBF7FF"}));
}

ArrowLeft.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
